<script>
  import Star from './Star.svelte';
  import { External } from '../../../../external';

  export let onChange = () => {},
    readOnly = false,
    starClass = '',
    defaultScore = 0;

  let config = {
    readOnly: readOnly,
    countStars: 5,
    range: { min: 0, max: 5, step: 1 },
    score: defaultScore,
    showScore: false,
    scoreFormat: function () {
      return `(${this.score.toFixed(0)}/${this.countStars})`;
    },
    starConfig: {
      size: 50,
      fillColor: '#ec9b32',
      unfilledColor: '#FFFFFF',
      strokeUnfilledColor: '#ec9b32'
    }
  };

  const onSliderChanged = (event) => {
    config.score = parseFloat(event.target.value);
    onChange(config.score);
  };

  const starRatingCss = `${External.resources}/styles/star-rating.css?v=${External.resourcesVersion}`;
</script>

<svelte:head>
  <link rel="stylesheet" type="text/css" href={starRatingCss} />
</svelte:head>
<section class="stars-container">
  <div class="range-stars">
    <div class="stars {starClass}">
      {#each Array(config.countStars) as star, id}
        {#if parseInt(config.score) === id}
          <Star
            id={config.name + id}
            starConfig={config.starConfig}
            fillPercentage={config.score - parseInt(config.score)} />
        {:else if parseInt(config.score) > id}
          <Star id={config.name + id} starConfig={config.starConfig} fillPercentage={1} />
        {:else}
          <Star id={config.name + id} starConfig={config.starConfig} fillPercentage={0} />
        {/if}
      {/each}
    </div>
    <input
      name={config.name}
      class="slider"
      type="range"
      min={config.readOnly ? config.score : config.range.min}
      max={config.readOnly ? config.score : config.range.max}
      step={config.range.step}
      bind:value={config.score}
      on:change={onSliderChanged} />
  </div>
  {#if config.showScore}
    <span class="show-score" style="font-size: {config.starConfig.size / 2}px;">
      {#if config.scoreFormat}
        {config.scoreFormat()}
      {:else}
        ({parseFloat((config.score / config.countStars) * 100).toFixed(2)}%)
      {/if}
    </span>
  {/if}
</section>
